import { router, usePage } from "@inertiajs/react";
import { Box, Grid } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { ReactTyped } from "react-typed";

import CompensationSlider from "../../components/compensations/CompensationSlider";
import AcceptedCount from "../../components/events/AcceptedCount";
import EventList from "../../components/events/EventList";
import Container from "../../components/layout/Container";
import Main from "../../components/layout/Main";
import MetaData from "../../components/MetaData";
import Body from "../../components/theme/Body";
import Heading from "../../components/theme/Heading";
import { Compensation } from "../../types/Compensation";
import { Event } from "../../types/Event";

const SEO_TITLE = "Home";
const SEO_DESCRIPTION =
  "Vraag reiskosten vergoeding voor een demonstratie of betaal die van een demonstrant.";

const STRINGS = [
  "voor <strong>klimaatrechtvaardigheid</strong>",
  "voor <strong>betaalbare woningen</strong>",
  "om <strong>de straat op te gaan</strong>",
  "voor een <strong>vrij Palestina</strong>",
  "voor <strong>schone lucht</strong>",
  "voor <strong>eerlijke herverdeling</strong>",
].reduce<string[]>(
  (prev, cur) => [...prev, cur, "voor <strong>Solidaritijd</strong>"],
  [],
);

const Home = () => {
  const { acceptedCount, compensations, events } = usePage<{
    acceptedCount: number;
    events: Event[];
    compensations: Compensation[];
  }>().props;
  const hasCompensations = compensations.length > 0;
  const hasMultipleCompensations = compensations.length > 1;

  return (
    <div>
      <MetaData description={SEO_DESCRIPTION} title={SEO_TITLE} />
      <Main>
        <Heading component="h1" variant="h1">
          Hoe laat is het?
        </Heading>
        <Heading
          component="h2"
          marginTop="0.5em"
          sx={{
            "& strong": {
              color: "primary.main",
            },
          }}
          variant="h3"
        >
          Tijd&nbsp;
          <ReactTyped
            loop
            backDelay={1800}
            backSpeed={10}
            strings={STRINGS}
            typeSpeed={15}
          />
        </Heading>
      </Main>
      <Container>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            marginTop: { xs: "2em", sm: "4em" },
            gap: "2em",
          }}
        >
          <Card sx={{ width: "100%" }}>
            <CardContent>
              <Heading component="h2" variant="h2">
                Voor demonstranten
              </Heading>
              <Heading color="primary" component="h3" variant="h4">
                Reiskosten te hoog?
              </Heading>
              <Body marginTop="1em">
                Wil je naar een demonstratie maar vind je de reiskosten te hoog?
                Plaats hier een aanvraag zodat een sympathisant de kosten voor
                je kan betalen!
              </Body>
            </CardContent>
          </Card>
          <Card sx={{ width: "100%" }}>
            <CardContent>
              <Heading component="h2" variant="h2">
                Voor sympathisanten
              </Heading>
              <Heading color="primary" component="h3" variant="h4">
                Geen tijd om te demonstreren?
              </Heading>
              <Body marginTop="1em">
                Sta je achter een demonstratie en wil je anderen helpen om eraan
                deel te nemen? Betaal de reiskosten van een demonstrant!
              </Body>
            </CardContent>
          </Card>
        </Box>
        <Heading component="h2" sx={{ marginTop: "2em" }} variant="h3">
          Komende demonstraties
        </Heading>
        <EventList events={events} />
        {hasCompensations && (
          <Heading
            component="h2"
            sx={{ marginBottom: "1em", marginTop: "2em" }}
            variant="h3"
          >
            Openstaande {hasMultipleCompensations ? "aanvragen " : "aanvraag "}
            {hasMultipleCompensations ? `(${compensations.length})` : null}
          </Heading>
        )}
        <Grid container spacing="2em" sx={{ marginTop: "1em" }}>
          {hasCompensations && (
            <Grid size={{ xs: 12, md: 6 }}>
              <Box maxWidth={800}>
                <CompensationSlider
                  global
                  compensations={compensations}
                  refreshList={() => router.reload()}
                />
              </Box>
            </Grid>
          )}
          <Grid size={{ xs: 12, md: 6 }}>
            <Box>
              <AcceptedCount global count={acceptedCount} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Home;
